import React from 'react';
import { DisplayText, Spinner, TextStyle } from '@superops/ui-design-system';
import styled from 'styled-components';

/* TODO: Fix in design system DSA */

const LoaderWrapper = styled.div`
  svg {
    fill: #d0d0d0 !important;
  }
`;

const TicketCount = (props) => {
  const { loading, count } = props;

  if (loading) {
    return (
      <LoaderWrapper>
        <Spinner size="small" />
      </LoaderWrapper>
    );
  }

  return (
    <DisplayText size="medium">
      <TextStyle variation="subdued">{count}</TextStyle>
    </DisplayText>
  );
};

export default TicketCount;
